<ng-container *ngIf="loaded">
<app-settings-header text="A/C Type Management" [showSaveButton]="false" [textSize]="20"></app-settings-header>
<app-settings-card (onAddClicked)="doAdd()" sectionTitle="A/C Types" addText="Add Aircraft Type">
  <app-settings-data-table class="mt-3" [columns]="['Aircraft Type','IATA Code', 'ICAO Code', 'Description', 'Calibration', 'Fire Category']" [data]="this.acTypes" [variableNames]="['alias', 'iata', 'icao', 'description', 'calibration', 'fireCategory']" (onEditClicked)="doEdit($event)" (onDeleteClicked)="doDelete($event)">
  </app-settings-data-table>
</app-settings-card>

<app-settings-card sectionTitle="Seating Configurations">
  <div class="flex flex-column dark-blue gap-3" *ngIf="activeAcTypeId">
    <div class="flex flex-column gap-2">
      <div class="ac-type">Aircraft ICAO Code</div>
      <div class="ac-select">
        <select class="form-control form-select light-blue-border" [(ngModel)]="selectedAcType" (ngModelChange)="selectedAcTypeChanged()">
          <option *ngFor="let acType of acTypes" [ngValue]="acType">{{ acType.icao }}</option>
        </select>
      </div>
    </div>
    <div class="overflow-auto avitium-scrollbar">
      <table class="table table-striped turnaround-table dark-blue">
        <thead>
        <tr>
          <th scope="col" *ngFor="let pClass of passengerClasses">
            {{pClass?.code}}
          </th>
          <th scope="col">
            Valid from
          </th>
          <th scope="col">
            Valid To
          </th>
          <th scope="col">
            Operated by
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let seat of Object.keys(seatingConfigurationsForSelectedAcType)">
          <td *ngFor="let pClass of passengerClasses">
            {{ getNumberForSeatsForCode(+seat, pClass.code) }}
          </td>
          <td>{{ seatingConfigurationsForSelectedAcType[seat]?.length && seatingConfigurationsForSelectedAcType[seat][0].validFrom ?  dayjs.utc(seatingConfigurationsForSelectedAcType[seat][0].validFrom).format(dateFormat) : '-' }}</td>
          <td>{{ seatingConfigurationsForSelectedAcType[seat]?.length && seatingConfigurationsForSelectedAcType[seat][0].validTo ?  dayjs.utc(seatingConfigurationsForSelectedAcType[seat][0].validTo).format(dateFormat) : '-' }}</td>
          <td>{{ seatingConfigurationsForSelectedAcType[seat]?.length ? getDesignatorNameFromId(seatingConfigurationsForSelectedAcType[seat][0].operatedBy) : '-' }}</td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</app-settings-card>

<app-settings-card sectionTitle="Turnaround Times: Domestic to Domestic">
  <div class="flex flex-column dark-blue gap-3" *ngIf="DOMDOM[activeAcTypeId] && flightServiceTypes?.length">
    <div class="flex flex-column gap-2">
      <div class="ac-type">Aircraft ICAO Code</div>
      <div class="ac-select">
        <select class="form-control form-select light-blue-border" [(ngModel)]="selectedAcType" (ngModelChange)="selectedAcTypeChanged()">
          <option *ngFor="let acType of acTypes" [ngValue]="acType">{{ acType.icao }}</option>
        </select>
      </div>
    </div>
    <div class="overflow-auto avitium-scrollbar">
      <table class="table table-striped turnaround-table dark-blue">
        <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" *ngFor="let flightServiceType of flightServiceTypes">
            Outbound {{flightServiceType?.code}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let flightServiceType of flightServiceTypes">
          <td class="text-center">Inbound {{flightServiceType?.code}}</td>
          <td *ngFor="let serviceType of flightServiceTypes">
            {{ DOMDOM?.[activeAcTypeId]?.[flightServiceType?.id]?.[serviceType?.id] | timeFromMinutes }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</app-settings-card>

<app-settings-card sectionTitle="Turnaround Times: Domestic to International">
  <div class="flex flex-column dark-blue gap-3" *ngIf="DOMINT[activeAcTypeId]">
    <div class="flex flex-column gap-2">
      <div class="ac-type">Aircraft ICAO Code</div>
      <div class="ac-select">
        <select class="form-control form-select light-blue-border" [(ngModel)]="selectedAcType" (ngModelChange)="selectedAcTypeChanged()">
          <option *ngFor="let acType of acTypes" [ngValue]="acType">{{ acType.icao }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-auto avitium-scrollbar">
      <table class="table table-striped turnaround-table dark-blue">
        <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" *ngFor="let flightServiceType of flightServiceTypes">
            Outbound {{flightServiceType?.code}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let flightServiceType of flightServiceTypes">
          <td class="text-center">Inbound {{flightServiceType?.code}}</td>
          <td *ngFor="let serviceType of flightServiceTypes">
            {{ DOMINT?.[activeAcTypeId]?.[flightServiceType?.id]?.[serviceType?.id] | timeFromMinutes }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-settings-card>




<app-settings-card sectionTitle="Turnaround Times: International to International">
  <div class="flex flex-column dark-blue gap-3" *ngIf="INTINT[activeAcTypeId]">
    <div class="flex flex-column gap-2">
      <div class="ac-type">Aircraft ICAO Code</div>
      <div class="ac-select">
        <select class="form-control form-select light-blue-border" [(ngModel)]="selectedAcType" (ngModelChange)="selectedAcTypeChanged()">
          <option *ngFor="let acType of acTypes" [ngValue]="acType">{{ acType.icao }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-auto avitium-scrollbar">
      <table class="table table-striped turnaround-table dark-blue">
        <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" *ngFor="let flightServiceType of flightServiceTypes">
            Outbound {{flightServiceType?.code}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let flightServiceType of flightServiceTypes">
          <td class="text-center">Inbound {{flightServiceType?.code}}</td>
          <td *ngFor="let serviceType of flightServiceTypes">
            {{ INTINT?.[activeAcTypeId]?.[flightServiceType?.id]?.[serviceType?.id] | timeFromMinutes }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-settings-card>

<app-settings-card sectionTitle="Turnaround Times: International to Domestic">
  <div class="flex flex-column dark-blue gap-3" *ngIf="INTDOM[activeAcTypeId]">
    <div class="flex flex-column gap-2">
      <div class="ac-type">Aircraft ICAO Code</div>
      <div class="ac-select">
        <select class="form-control form-select light-blue-border" [(ngModel)]="selectedAcType" (ngModelChange)="selectedAcTypeChanged()">
          <option *ngFor="let acType of acTypes" [ngValue]="acType">{{ acType.icao }}</option>
        </select>
      </div>
    </div>

    <div class="overflow-auto avitium-scrollbar">
      <table class="table table-striped turnaround-table dark-blue">
        <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col" *ngFor="let flightServiceType of flightServiceTypes">
            Outbound {{flightServiceType?.code}}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let flightServiceType of flightServiceTypes">
          <td class="text-center">Inbound {{flightServiceType?.code}}</td>
          <td *ngFor="let serviceType of flightServiceTypes">
            {{ INTDOM?.[activeAcTypeId]?.[flightServiceType?.id]?.[serviceType?.id] | timeFromMinutes }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-settings-card>
</ng-container>
